import { Utils } from '@pacem/pacem-core';
import { parseAsNumericalArray } from '@pacem/pacem-foundation';
import { Geometry } from '@pacem/pacem-numerical';
//namespace Pacem.Drawing3D {
export const Point3DConverter = {
    convert: (attr) => Geometry.LinearAlgebra.Vector3D.parse(attr),
    convertBack: (prop) => `${prop.x || 0} ${prop.y || 0} ${prop.z || 0}`
};
export const Point3DOrNumberConverter = {
    convert: (attr) => {
        const arr = parseAsNumericalArray(attr);
        const throwErr = () => { throw new Error(`Cannot parse "${attr}" as a valid Vector3D.`); };
        if (Utils.isNullOrEmpty(arr)) {
            throwErr();
        }
        if (arr.length === 3) {
            return Geometry.LinearAlgebra.Vector3D.from(...arr);
        }
        if (arr.length === 1) {
            const v = arr[0];
            return Geometry.LinearAlgebra.Vector3D.from(v, v, v);
        }
        throwErr();
    },
    convertBack: (prop) => `${prop.x || 0} ${prop.y || 0} ${prop.z || 0}`
};
export const QuaternionConverter = {
    convert: (attr) => Geometry.LinearAlgebra.Quaternion.parse(attr),
    convertBack: (prop) => `${prop.x || 0} ${prop.y || 0} ${prop.z || 0} ${prop.w || 0}`
};
export const BooleanOrNumberConverter = {
    convert: (attr) => {
        if (attr === 'true')
            return true;
        if (attr === 'false')
            return false;
        return parseAsNumericalArray(attr)[0];
    },
    convertBack: (prop) => prop.toString()
};
